import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { ContentType, LegalDisclaimer } from 'api/contentful/contentTypes.cloverdotcom';
import { Entries } from 'api/contentful/utilTypes';
import { ArrayFlatEntry } from 'services/cms/flattenContentful';
import { fetchFlatEntries } from 'utils/fetchFlatEntries';

export function useContentfulLegalDisclaimers() {
  const [disclaimersList, setDisclaimersList] = useState<ArrayFlatEntry<Entries<LegalDisclaimer>>>([]);
  const [pageDisclaimers, setPageDisclaimers] = useState<Array<string>>([]);

  const { language } = useTranslation().i18n;
  const { pathname } = useLocation();

  useEffect(() => {
    const CONTENT_TYPE = ContentType.LEGAL_DISCLAIMER;
    const fetchLegalDisclaimers = async () => {
      try {
        const legalDisclaimerEntries = await fetchFlatEntries<LegalDisclaimer>(language, {
          contentType: CONTENT_TYPE,
          include: 1,
        });

        setDisclaimersList(legalDisclaimerEntries || []);
      } catch (err) {
        console.error(`Problem pulling ${CONTENT_TYPE} from Contentful`, err);
      }
    };

    fetchLegalDisclaimers();
  }, [language]);

  useEffect(() => {
    const matchingPages = disclaimersList.filter(disclaimer =>
      disclaimer.pages?.some(page => {
        if (!page.slug) return false;

        const pageSlug = page.slug.startsWith('/') ? page.slug : `/${page.slug}`;
        return pageSlug === pathname;
      }),
    );

    const currentPageDisclaimers: string[] = matchingPages.map(disclaimer => disclaimer.disclaimerText || '');
    setPageDisclaimers(currentPageDisclaimers);
  }, [disclaimersList, pathname]);

  return pageDisclaimers;
}
